import * as React from "react";
import classnames from "classnames";
import { EMDASH } from "@eave/shared/utils/general";

import DropdownModal from "../../../shared/DropdownModal";

const FontAwesome = require("react-fontawesome");

const styles = require("./styles.module.scss");

/* helpers */

const OriginalValue: React.SFC<any> = ({ val, editing, formatting, onDoubleClick }) => {
  const classes = classnames({
    [styles.editVal__original]: !editing,
  });

  let display = val;
  if (val === null || val === undefined || val === "") {
    display = EMDASH;
  } else if (typeof formatting === "function") {
    display = formatting(val);
  }

  return (
    <div onDoubleClick={onDoubleClick} className={classes}>
      {display}
    </div>
  );
};

const Button: React.SFC<any> = ({ onClick, children }) => (
  <div onClick={onClick} className={styles.confirmButton}>
    {children}
  </div>
);
/* main */

const uiTextToWs = uiText => (uiText === "" ? null : uiText);
const wsTextToUi = wsText => (wsText === null ? "" : wsText);

const initProps = ({ value }) => ({
  editing: false,
  currentValue: wsTextToUi(value),
});

interface IProps {
  value: any;
  onUpdate: Function;
  precision?: number; // for NUMBER
  disallowNegative?: boolean; // for NUMBER
  formatting?: Function;
}

class EditableTextValue extends React.Component<IProps, any> {
  constructor(props) {
    super(props);
    this.state = initProps(props);

    this.stopEditingAndUpdate = this.stopEditingAndUpdate.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(initProps(nextProps));
  }

  onKeyDown(e) {
    if (e.key === "Enter" || e.key === "Escape") {
      e.preventDefault();
      e.stopPropagation();

      if (e.key === "Enter") {
        this.stopEditingAndUpdate();
      } else {
        this.stopEditingAndRevert();
      }
    }
  }

  onChange(e) {
    const { precision, disallowNegative } = this.props;

    let val;

    if (typeof precision === "number") {
      val = e.target.value.replace(/[%$, ]/g, ""); // strip dollar signs, percent signs, spaces, and commas, to allow numeric values to be more easily copied and pasted into worksheets
    } else {
      val = e.target.value;
    }

    if (typeof precision === "number") {
      let checks;
      if (precision < 1 && disallowNegative) {
        checks = [/^\d+$/.test(val)];
      } else if (precision < 1) {
        checks = [/^-?\d*$/.test(val)];
      } else if (disallowNegative) {
        checks = [/^\d+$/.test(val), new RegExp(`^\\d+\\.\\d{0,${precision}}$`).test(val)];
      } else {
        checks = [/^-?\d*$/.test(val), new RegExp(`^-?\\d*\\.\\d{0,${precision}}$`).test(val)];
      }

      if (![val === "", ...checks].some(Boolean)) {
        return;
      }
    }

    this.setState({
      ...this.state,
      currentValue: val,
    });
  }

  stopEditingAndRevert() {
    this.setState(initProps(this.props));
  }

  stopEditingAndUpdate() {
    this.toggleEditing(false);
    let val = uiTextToWs(this.state.currentValue);
    if (val && val[val.length - 1] === ".") {
      val = val.substr(0, val.length - 1);
    }

    // only update if changed
    if (val !== this.props.value) {
      this.props.onUpdate(val);
    }
  }

  toggleEditing(editing: boolean) {
    this.setState({
      ...this.state,
      editing,
    });
  }

  render() {
    const { editing, currentValue } = this.state;
    const { value, formatting } = this.props;

    const val = wsTextToUi(value);

    return (
      <div className={styles.editVal__container}>
        {editing ? (
          <div className={styles.editVal__select}>
            <input
              type="text"
              autoFocus
              value={currentValue}
              onKeyDown={this.onKeyDown}
              onChange={this.onChange}
              onFocus={e => e.currentTarget.select()}
              onBlur={this.stopEditingAndUpdate}
            />
          </div>
        ) : (
          <>
            <OriginalValue
              val={val}
              editing={editing}
              formatting={formatting}
              onDoubleClick={() => this.toggleEditing(true)}
            />
            {val !== "" && (
              <DropdownModal leanRight>
                {{
                  trigger: <FontAwesome className={styles.editVal__button} name="times" />,
                  content: <Button onClick={() => this.props.onUpdate(null)}>Delete</Button>,
                }}
              </DropdownModal>
            )}
          </>
        )}
      </div>
    );
  }
}

export default EditableTextValue;
